var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LiOverlay',{staticClass:"v-loading__overlay",attrs:{"type":"white","show":_vm.show}},[_c('LiLoading',{staticClass:"v-loading__loading"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }